import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { SalesCallTrackingGrid, ServiceThreadSpinner } from '.';
import { api, constants, helpers } from '../utils';

export default function SalesDashboardSalesCallLog(props) {
  const [data, setData] = useState();
  const [loaded, setLoaded] = useState(false);
  const [salespersonId, setSalespersonId] = useState(props.salespersonId);
  const [sortDirection, setSortDirection] = useState("asc");
  const [sortField, setSortField] = useState("SalesCallDisplayId");

  useEffect(() => {
    let newLoaded = loaded;
    if (props.salespersonId !== salespersonId) {
      setSalespersonId(props.salespersonId);
      newLoaded = false;
    }
    if (newLoaded !== loaded) {
      setLoaded(newLoaded);
    }
    if (!newLoaded) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, props.salespersonId])

  function createPayload() {
    return {
      SortField: sortField,
      SortDirection: sortDirection,
      SalespersonId: props.salespersonId,
      ActionType: constants.SALES_CALL_TRACKING_ACTION_TYPES.None,
      CustomerId: '',
      ContactOther: '',
      CalledFromSalesDashboard: true
    }
  }

  function exportXlsx() {
    const payload = createPayload()
    api
      .postGetBlob("Sales/ExportSalesCallTrackingXLSX", payload)
      .then(r => {
        if (r.data.success === false) {
          if (_.isString(r?.data?.message)) {
            toast.error(r?.data?.message);
          }
          return;
        }
        if (r.data) {
          const XLSX_FILENAME = payload.SalespersonId
            ? `${payload.SalespersonId}_Sales_Call_Tracking.xlsx`
            : `Sales_Call_Tracking.xlsx`
          helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
        } else {
          toast.error(r.message || "Error downloading report");
        }
      })
      .catch(api.catchHandler);
  }

  function loadData() {
    api
      .post(`Sales/SalesCallTrackingSearch`, createPayload())
      .then(response => {
        if (response.data.success && response.data.message.items) {
          setData(response.data.message.items);
        }
        setLoaded(true);
      })
      .catch(api.catchHandler);
  }

  function onPageChange() {
    // ^page
    // setPage(page);
    setLoaded(false);
  }

  function onSortChange(field, direction) {
    if (field !== sortField) {
      setSortField(field);
      setSortDirection("asc")
    } else {
      setSortDirection(direction);
    }
    onPageChange(1);
  }

  return (
    <React.Fragment>
      <div>
        <span className="h2 me-2">Sales Call Tracking 30 Days</span>
      </div>
      <hr />
      <ServiceThreadSpinner on={!loaded}>
        {data && data.length > 0
          ? (<SalesCallTrackingGrid
              salesCallTrackingData={data}
              sortCallback={onSortChange}
              sortField={sortField}
              sortDirection={sortDirection}
              exportXlsxCallback={exportXlsx}
              calledFromSalesDashboard
              displayOnlyId
            />)
          : (<span className="h5" style={{ color: "red" }}>No sales calls found</span>)
        }
      </ServiceThreadSpinner>
    </React.Fragment>
  );
};
